import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense, useEffect, useState } from "react";

// Studio is heavy and browser-only — code-split + client-only.
const StudioEmbed = lazy(() => import("@/components/StudioEmbed"));

export const Route = createFileRoute("/admin")({
  head: () => ({
    meta: [
      { title: "Content Studio — AMR 3 Design & Construction" },
      { name: "description", content: "Private content editing studio for the AMR 3 Design & Construction website. Not intended for public visitors." },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [{ rel: "canonical", href: "https://www.amr3designconstruction.com/admin" }],
  }),
  component: AdminPage,
});

function AdminPage() {
  // Avoid SSR/prerender of Sanity Studio.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <div className="fixed inset-0 z-[100] bg-background">
      {mounted ? (
        <Suspense
          fallback={
            <div className="flex h-full w-full items-center justify-center text-sm text-muted-foreground">
              Loading Studio…
            </div>
          }
        >
          <StudioEmbed />
        </Suspense>
      ) : null}
    </div>
  );
}
